function PreconceptionCare() {
    return (
      <div className="container my-5">
        <h2 className="text-center mb-4">Preconception Care Package</h2>
        
        <div className="card mb-4">
          <div className="card-header bg-danger text-white">
            <h3>Key Components</h3>
          </div>
          <div className="card-body">
            <ul className="list-group list-group-flush">
              <li className="list-group-item">
                <h5>1. Health Assessment</h5>
                <p>Medical history review and comprehensive physical exam</p>
              </li>
              <li className="list-group-item">
                <h5>2. Nutrition Planning</h5>
                <p>Balanced diet with folic acid supplementation (400-800mcg daily)</p>
              </li>
              <li className="list-group-item">
                <h5>3. Lifestyle Management</h5>
                <p>Substance avoidance, stress management, and sleep hygiene</p>
              </li>
              <li className="list-group-item">
                <h5>4. Chronic Condition Control</h5>
                <p>Management of diabetes, hypertension, and thyroid disorders</p>
              </li>
              <li className="list-group-item">
                <h5>5. Genetic Counseling</h5>
                <p>Family history analysis and genetic testing options</p>
              </li>
            </ul>
          </div>
        </div>
  
        <div className="alert alert-danger">
          <h4>Expected Outcome</h4>
          <p>Enhanced chances of healthy pregnancy when starting care at least 3 months pre-conception</p>
        </div>
      </div>
    );
  }

  export default PreconceptionCare;